// extracted by extract-css-chunks-webpack-plugin
module.exports = {"paymentTypesContainer":"tFKt71Ec","paymentType":"puVXCyfB","selected":"SX44nyye","paymentTypeText":"eWWJhfkR","paymentTypePriceText":"hWk8qgf_","footer":"CBcL9S85"};